export function disableScroll() {
	const isClient = typeof window !== 'undefined';
	if (!isClient) return;

	// const paddingOffset = `${window.innerWidth - document.body.offsetWidth}px`;
	// const header = document?.querySelector('#top_menu');
	// document.body.style.overflow = 'hidden';
	// document.body.style.paddingRight = paddingOffset;
	// if (header) {
	// 	header.style.paddingRight = paddingOffset;
	// }
}

export function activeScroll() {
	const isClient = typeof window !== 'undefined';
	if (!isClient) return;

	// const header = document?.querySelector('#top_menu');
	// document.body.style.overflow = 'auto';
	// document.body.style.paddingRight = '0px';
	// if (header) {
	// 	header.style.paddingRight = '0px';
	// }
}
